<template>
  <svg width="145" height="50" viewBox="0 0 145 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4398_8011)">
      <mask id="mask0_4398_8011" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="1" width="27" height="36">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.40527H26.5776V36.9046H0V1.40527Z" fill="white" />
      </mask>
      <g mask="url(#mask0_4398_8011)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.52401 31.8722H14.0814C18.5636 31.8722 21.0087 29.7413 21.0087 26.5223C21.0087 23.4394 18.6092 21.3085 13.7193 21.3085H5.52401V31.8722ZM5.52401 16.4121H12.4968C17.0698 16.4121 19.3785 14.2812 19.3785 11.3342C19.3785 8.38727 17.3412 6.43769 12.8138 6.43769H5.52401V16.4121ZM0 1.40527H13.5379C16.979 1.40527 19.741 2.22134 21.8235 3.89877C23.9063 5.57632 24.9475 7.8431 24.9475 10.7448C24.9475 11.5155 24.8117 12.3316 24.5854 13.1931C24.0876 14.8252 22.4124 17.2734 19.8312 18.4068C22.2762 19.1777 23.997 20.4017 25.0381 21.9885C26.0794 23.5754 26.5776 25.2528 26.5776 26.9757C26.5776 32.9603 22.186 36.9046 13.9907 36.9046H0V1.40527Z"
          fill="#040A34"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M43.9509 18.1349C43.4982 18.0444 43.0004 17.9989 42.4115 17.9989C38.2913 17.9989 36.1182 20.4018 36.1182 24.6183V36.9048H30.7305V12.6945H35.9821V16.5481C37.4764 13.8279 39.695 12.4678 42.6378 12.4678C43.2268 12.4678 43.6339 12.5132 43.9509 12.6038V18.1349Z"
        fill="#040A34"
      />
      <mask
        id="mask1_4398_8011"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="145"
        height="50"
      >
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 49.01H145V0H0V49.01Z" fill="white" />
      </mask>
      <g mask="url(#mask1_4398_8011)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M48.5224 36.905H53.9102V12.6947H48.5224V36.905ZM48.7032 2.35765C50.107 0.906824 52.28 0.906824 53.6839 2.35765C55.0872 3.76306 55.0872 5.93925 53.6839 7.34466C52.28 8.75019 50.107 8.75019 48.7032 7.34466C47.2995 5.93925 47.2995 3.76306 48.7032 2.35765Z"
          fill="#040A34"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M65.6875 19.3139C64.3743 20.81 63.6953 22.6235 63.6953 24.7544C63.6953 26.8852 64.3743 28.6987 65.6875 30.1949C67.0456 31.6458 68.8115 32.3711 70.9395 32.3711C73.0674 32.3711 74.8333 31.6458 76.146 30.1949C77.5047 28.6987 78.1838 26.8852 78.1838 24.7544C78.1838 22.6235 77.5047 20.81 76.146 19.3139C74.7877 17.8178 73.0674 17.0923 70.9395 17.0923C68.8115 17.0923 67.0456 17.8178 65.6875 19.3139ZM61.5222 16.0495C63.7403 13.5107 66.6836 12.2412 70.2604 12.2412C71.5736 12.2412 72.9769 12.5585 74.5163 13.2387C76.1009 13.8733 77.2783 14.8254 78.0931 16.1402V0H83.4809V36.9048H78.2288V33.1418C77.369 34.5473 76.1461 35.5901 74.4712 36.27C72.8412 36.9502 71.3923 37.2675 70.1242 37.2675C66.7286 37.2675 63.8761 36.0434 61.6124 33.5499C59.3487 31.0563 58.2168 28.1093 58.2168 24.7543C58.2168 21.4901 59.3037 18.5885 61.5222 16.0495Z"
          fill="#040A34"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M105.167 19.2686C103.854 17.8178 102.088 17.0924 99.96 17.0924C97.8321 17.0924 96.0662 17.8178 94.753 19.2686C93.4403 20.674 92.7608 22.4876 92.7608 24.6185C92.7608 26.7494 93.4403 28.5628 94.753 30.0591C96.1113 31.5098 97.8321 32.2352 99.96 32.2352C102.088 32.2352 103.809 31.5098 105.122 30.0591C106.48 28.5628 107.159 26.7494 107.159 24.6185C107.159 22.4876 106.48 20.7195 105.167 19.2686ZM90.6784 33.4139C88.4598 30.9657 87.373 28.0641 87.373 24.7091C87.373 21.4902 88.4598 18.6339 90.6333 16.095C92.8519 13.556 95.7496 12.2866 99.3264 12.2866C100.639 12.2866 102.043 12.6494 103.582 13.3294C105.122 14.0094 106.344 15.0069 107.204 16.367V12.6947H112.456V36.5876C112.456 40.3959 111.279 43.4336 108.97 45.6552C106.661 47.8767 103.627 49.0101 99.8242 49.0101C93.9381 49.0101 89.8631 46.5619 87.6449 41.6654L92.1273 39.0811C93.8024 42.4815 96.3381 44.2044 99.7337 44.2044C103.944 44.2044 107.068 41.6654 107.068 36.8143V33.0059C106.208 34.4114 104.986 35.4088 103.401 36.0889C101.816 36.7689 100.413 37.0862 99.1451 37.0862C95.7496 37.0862 92.897 35.8623 90.6784 33.4139Z"
          fill="#040A34"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M119.697 36.9046H125.085V12.6943H119.697V36.9046Z"
          fill="#2CDD80"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M139.068 17.5458V28.2455C139.068 31.1471 140.471 32.2805 143.233 32.2805C143.777 32.2805 144.365 32.2352 144.954 32.0992V36.6783C144.094 36.9956 143.097 37.1769 142.056 37.1769C136.759 37.1769 133.68 34.366 133.68 29.1069V17.5458H129.242V12.6947H133.68V5.21387H139.068V12.6947H144.999V17.5458H139.068Z"
          fill="#2CDD80"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M112.525 8.98744C112.525 7.00732 114.134 5.39632 116.111 5.39632C118.089 5.39632 119.697 7.00732 119.697 8.98744L125.086 8.98756C125.086 4.0318 121.06 0 116.111 0C111.162 0 107.135 4.03168 107.135 8.98744H112.525Z"
          fill="#2CDD80"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4398_8011">
        <rect width="145" height="50" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
